'use strict';

var Model = require('base/Colido.Model')

/**
 * Model for a single catalog subtype
 *
 * @category   Model
 * @module     global
 * @copyright  Copyright (c) 2014, COLIDO (http://www.colido.net)
 * @author     Augusto Campos-Leiva <augusto@campos-leiva.de>
 */
var SubtypeModel = Model.extend({
    api: '/core/subtypes',

    idAttribute: 'key',

    defaults: {
        key: '',
        label: '',
    },
});

module.exports = SubtypeModel;